/**
 * DataContext is retained as a placeholder for future global UI state
 * (e.g. current user, sidebar preferences, notification toasts).
 *
 * All server data (cases, graph, transactions, red flags, analysis) is now
 * fetched via React Query hooks in src/hooks/.
 */
import React, { createContext } from 'react';

export const DataContext = createContext({});

export const DataProvider = ({ children }) => (
  <DataContext.Provider value={{}}>
    {children}
  </DataContext.Provider>
);
